import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
});

api.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('@up2_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  const user = localStorage.getItem('@up2_api_user');
  const pass = localStorage.getItem('@up2_api_pass');
  const cnpj = localStorage.getItem('@up2_cnpj');

  if (user) config.headers['x-api-user'] = user;
  if (pass) config.headers['x-api-pass'] = pass;
  if (cnpj) config.headers['x-api-cnpj'] = cnpj;

  return config;
});

export default api;